// © ООО «Эдиспа», 2022

import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from 'antd';

import IconButton from 'grid/components/toolbar/IconButton';
import { usePowerGridDispatch } from 'grid/context';
import { actions, PowerGridFeature } from 'grid/store';
import { IconImportSvg } from 'svg';

const ImportFromJsonButton: FunctionComponent = () => {
  const dispatch = usePowerGridDispatch();

  const onClick = () =>
    dispatch(actions.setActiveFeature(PowerGridFeature.IMPORT_FROM_JSON));

  return (
    <Tooltip
      mouseEnterDelay={1}
      title={<FormattedMessage id="button.import" />}
    >
      <IconButton onClick={onClick}>
        <IconImportSvg />
      </IconButton>
    </Tooltip>
  );
};

export default ImportFromJsonButton;
